// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/experiment_excluded_replicates.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/experiment_excluded_replicates.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_experiment_excluded_replicates: GenFile = /*@__PURE__*/
  fileDesc("CkxxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZXhwZXJpbWVudF9leGNsdWRlZF9yZXBsaWNhdGVzLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEiNQocRXhwZXJpbWVudEV4Y2x1ZGVkUmVwbGljYXRlcxIVCg1yZXBsaWNhdGVfaWRzGAEgAygJYgZwcm90bzM");

/**
 * A group of individual replicates to be excluded from
 * analysis (e.g. outliers)
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ExperimentExcludedReplicates
 */
export type ExperimentExcludedReplicates = Message<"quanterix.simoa_one.analysis_app_api.v1.ExperimentExcludedReplicates"> & {
  /**
   * Unique ids (UUID) for each excluded replicate
   *
   * @generated from field: repeated string replicate_ids = 1;
   */
  replicateIds: string[];
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ExperimentExcludedReplicates.
 * Use `create(ExperimentExcludedReplicatesSchema)` to create a new message.
 */
export const ExperimentExcludedReplicatesSchema: GenMessage<ExperimentExcludedReplicates> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_experiment_excluded_replicates, 0);

